import { differenceInDays, isSameDay } from 'date-fns'
import { toLocalDate } from '../../../../../utility'

export class TravelDates {
    public nights: number | undefined

    constructor(public checkin: Date | undefined, public checkout: Date | undefined) {
        this.checkin = checkin
        this.checkout = checkout

        if (this.checkin && this.checkout) {
            this.nights = differenceInDays(this.checkout, this.checkin)
        }
    }

    isSame(other: TravelDates): boolean {
        if (!other.checkin || !other.checkout || !this.checkin || !this.checkout) { 
            return false 
        }
    
        return isSameDay(this.checkin, other.checkin) && isSameDay(this.checkout, other.checkout)
    }

    toDatesCriterion() {
        if (!this.checkin || !this.checkout) {
            return undefined
        }

        return {
            checkin: toLocalDate(this.checkin),
            checkout: toLocalDate(this.checkout)
        }
    }
}
